<div class="multi-select3-dialog">

  <div class="multi-select3-dialog__header">
    <div class="search-field">
      <mat-icon class="search-field__icon">search</mat-icon>
      <input class="search-field__input" type="text" placeholder="Поиск" [formControl]="searchTerm">
    </div>
    <mat-icon class="close" (click)="close()">close</mat-icon>
  </div>

  <div class="checkbox-list">
    @for (item of filteredItems; track item) {
      @if (type !== 'checkbox') {
        <mat-radio-button [checked]="isSelected(item)"
                          (change)="toggleSelection(item)"
                          name="single"
        >
          <ng-container *ngTemplateOutlet="template||defaultTemplate; context:{$implicit: item}" ></ng-container>
        </mat-radio-button>
      } @else {
        <mat-checkbox [checked]="isSelected(item)"
                      (change)="toggleSelection(item)">
          <ng-container *ngTemplateOutlet="template||defaultTemplate; context:{$implicit: item}" ></ng-container>
        </mat-checkbox>
      }
      <ng-template #defaultTemplate let-item>
        {{ item.name }}
      </ng-template>
    }
  </div>

  <div class="actions">
    <button mat-flat-button color="primary" (click)="apply()">Применить</button>
    <button mat-flat-button (click)="reset()">Сбросить</button>
  </div>
</div>
